import React, { SVGProps } from 'react';

export const HourGlassIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 18,
  height = 23,
  fill = 'currentColor',
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 18 23"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.875 2.875C17.4963 2.875 18 2.39231 18 1.79688V1.07812C18 0.482686 17.4963 0 16.875 0H1.125C0.503672 0 0 0.482686 0 1.07812V1.79688C0 2.39231 0.503672 2.875 1.125 2.875C1.125 6.96132 3.51638 10.4099 6.78947 11.5C3.51638 12.5901 1.125 16.0387 1.125 20.125C0.503672 20.125 0 20.6077 0 21.2031V21.9219C0 22.5173 0.503672 23 1.125 23H16.875C17.4963 23 18 22.5173 18 21.9219V21.2031C18 20.6077 17.4963 20.125 16.875 20.125C16.875 16.0387 14.4836 12.5901 11.2105 11.5C14.4836 10.4099 16.875 6.96132 16.875 2.875Z"
        fill={fill}
      />
    </svg>
  );
};
